import React from 'react'
import classNames from 'classnames'

import styles from './GenericToggle.module.scss'

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const GenericToggle = React.forwardRef(({ children, onClick, ...props }, ref) => (
  <a
    href=""
    className={classNames(styles.genericToggle, props.className)}
    ref={ref}
    onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      onClick(e)
    }}
  >
    {children}
  </a>
))
GenericToggle.displayName = 'GenericToggle'

export default GenericToggle
